
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.56 2.508a1.65 1.65 0 00-.647-.053.748.748 0 00-.082.014 9.75 9.75 0 1011.7 11.7.75.75 0 00.019-.169 1.75 1.75 0 00-1.75-1.75H13A1.25 1.25 0 0111.75 11V4a1.65 1.65 0 00-1.19-1.492zM6.35 5.987a8.25 8.25 0 013.762-2.043.15.15 0 01.138.112V11A2.75 2.75 0 0013 13.75h6.8a.25.25 0 01.243.191A8.25 8.25 0 116.35 5.987zm8.072-3.303a1 1 0 01.91-.127 10 10 0 016.111 6.11A1 1 0 0120.5 10H16a2 2 0 01-2-2V3.5a1 1 0 01.422-.816z"}})])
          )
        }
      }
    